import axios from "../../../config/axiosConfig";

export const getReporteLibroVentas = ({ fechaIni, fechaFin }) =>
  axios.get("/api/reporte-libro-ventas", { params: { fechaIni, fechaFin } });
